<template>
    <div v-if="!isFetching">
        <div
            v-if="!dlcCampaigns.data.length"
            class="box-body with-border clearfix"
        >
            <p>There are no DLC Campaigns for this Api.</p>
        </div>

        <div v-else>
            <div class="box-body table-responsive no-padding">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Value</th>
                            <th v-if="withApis">API</th>
                            <th class="text-center">Numbers</th>
                            <th class="text-right">Created At</th>
                            <th class="text-right">Updated At</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="dlcCampaign in dlcCampaigns.data"
                            :key="dlcCampaign.id"
                        >
                            <td>{{ dlcCampaign.id }}</td>
                            <td>
                                <code>{{ dlcCampaign.value }}</code>
                            </td>
                            <td v-if="withApis">
                                <a :href="getRoute(dlcCampaign.api.id, 'apiShow')">
                                    <span
                                        :class="ifActive(dlcCampaign.api.active, 'text-red')"
                                        :title="ifActive(dlcCampaign.api.active, 'Disabled')"
                                        >{{ dlcCampaign.api.name }}</span
                                    >
                                </a>
                            </td>
                            <td class="text-center">
                                <BadgeTotal
                                    :value="dlcCampaign.numbers_count"
                                    color="gray"
                                    title="Total"
                                />
                            </td>
                            <td class="text-right">{{ dlcCampaign.created_at }}</td>
                            <td class="text-right">{{ dlcCampaign.updated_at }}</td>
                            <td class="text-right">
                                <a
                                    :href="getRoute(dlcCampaign.id, 'edit')"
                                    class="btn btn-sm btn-primary"
                                >
                                    <i class="fa fa-edit"></i>
                                    <span class="sr-only">Edit</span>
                                </a>
                                <a
                                    :href="getRoute(dlcCampaign.id, 'show')"
                                    class="btn btn-sm btn-info"
                                >
                                    <i class="fa fa-eye"></i>
                                    <span class="sr-only">Show</span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div
                class="box-footer clearfix"
                @click="preventEnter"
                @keydown="preventEnter"
            >
                <pagination
                    :class="isDisabled()"
                    class="pull-right no-margin vue-pagination"
                    :data="dlcCampaigns"
                    :size="$root.paginator.settings.size"
                    :limit="$root.paginator.settings.limit"
                    show-disabled
                    @pagination-change-page="getData"
                >
                    <span slot="prev-nav">
                        <i class="fa fa-angle-double-left"></i>
                    </span>
                    <span slot="next-nav">
                        <i class="fa fa-angle-double-right"></i>
                    </span>
                </pagination>
            </div>
        </div>
    </div>
</template>

<script>
import BadgeTotal from '../../subcomponents/BadgeTotal';

export default {
    components: {
        BadgeTotal,
    },
    props: {
        apiId: {
            type: Number,
            default: null,
        },
        withApis: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dlcCampaigns: {},
            disablePagination: true,
            isFetching: true,
            pageNumber: this.$route.query.pageDlc,
            route: {
                edit: '/apis/dlc-campaigns/:id:/edit',
                show: '/apis/dlc-campaigns/:id:',
                apiShow: '/apis/:id:',
            },
        };
    },
    mounted() {
        this.getData(this.pageNumber);
    },
    methods: {
        preventEnter: function (event) {
            if (this.disablePagination) {
                return event.preventDefault();
            }
        },
        getData: function (page = 1) {
            this.disablePagination = true;

            axios.get(`/apis/${this.apiId}/dlc-campaigns?page=${page}`).then((response) => {
                if (String(page) !== String(this.$route.query.pageDlc)) {
                    this.$router.push({ query: Object.assign({}, this.$route.query, { pageDlc: String(page) }) });
                }

                if (page > response.data.dlcCampaigns.last_page) {
                    return this.getData(1);
                }

                this.dlcCampaigns = response.data.dlcCampaigns;
                this.isFetching = false;
                this.disablePagination = false;
            });
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        ifActive: function (value, text) {
            return value ? '' : text;
        },
        isDisabled: function () {
            return this.disablePagination ? 'disabled-box' : '';
        },
    },
};
</script>
